import React, { useState, useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import SmartSearch from './SmartSearch';
import { LicenseContext } from './LicenseGate';

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const { deactivate, state, isOwner } = useContext(LicenseContext) || {};
  // Hide the customer-oriented "Deactivate This Device" button when the
  // studio was unlocked via the owner session — the owner signs out via /admin.
  const showAccess = state === 'unlocked' && !isOwner && typeof deactivate === 'function';
  const link = ({ isActive }) => `text-sm px-3 py-1.5 rounded-full transition-colors ${isActive ? 'text-white bg-zinc-800' : 'text-zinc-400 hover:text-white'}`;
  const mobileLink = ({ isActive }) => `block w-full text-left px-4 py-3 rounded-lg text-sm ${isActive ? 'text-white bg-zinc-800' : 'text-zinc-300 hover:bg-zinc-800'}`;
  const handleDeactivate = () => {
    if (!showAccess) return;
    if (window.confirm('Sign this device out of TYPE ELITE Studio? You will need to enter your license key again on this device.')) {
      deactivate();
    }
  };
  return (
    <header className="glass sticky top-0 z-40 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between gap-3">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 shrink-0 min-w-0">
          <span className="font-display text-xl sm:text-2xl tracking-widest uppercase truncate">Type Elite</span>
          <span className="hidden lg:inline eyebrow whitespace-nowrap">All-In-One Text Studio</span>
        </Link>
        <div className="hidden md:block flex-1 max-w-md"><SmartSearch /></div>
        <nav className="hidden md:flex items-center gap-1 shrink-0">
          <NavLink to="/studio" data-testid="nav-studio" className={link}>Studio</NavLink>
          <NavLink to="/presets" data-testid="nav-presets" className={link}>Presets</NavLink>
          <NavLink to="/projects" data-testid="nav-projects" className={link}>My Projects</NavLink>
          <Link to="/studio" data-testid="nav-start" className="ml-2 btn-magenta text-white text-xs px-4 py-2 rounded-full uppercase tracking-widest">Start Creating</Link>
          {showAccess && (
            <button
              data-testid="nav-deactivate"
              onClick={handleDeactivate}
              className="ml-1 text-zinc-500 hover:text-white p-2 rounded-full transition-colors"
              title="Deactivate this device"
              aria-label="Deactivate this device"
            >
              <LogOut size={14} />
            </button>
          )}
        </nav>
        <button data-testid="mobile-menu-toggle" onClick={() => setOpen((o) => !o)} className="md:hidden shrink-0 rounded-full p-2 chrome-border" aria-label="Toggle menu">
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-zinc-950/95 backdrop-blur px-4 py-3 space-y-2" data-testid="mobile-menu">
          <NavLink to="/studio" data-testid="mnav-studio" onClick={() => setOpen(false)} className={mobileLink}>Studio</NavLink>
          <NavLink to="/presets" data-testid="mnav-presets" onClick={() => setOpen(false)} className={mobileLink}>Presets</NavLink>
          <NavLink to="/projects" data-testid="mnav-projects" onClick={() => setOpen(false)} className={mobileLink}>My Projects</NavLink>
          <Link to="/studio" data-testid="mnav-start" onClick={() => setOpen(false)} className="btn-magenta text-white text-xs px-4 py-3 rounded-full uppercase tracking-widest w-full block text-center">Start Creating</Link>
          {showAccess && (
            <button
              data-testid="mnav-deactivate"
              onClick={() => { setOpen(false); handleDeactivate(); }}
              className="w-full text-left px-4 py-3 rounded-lg text-sm text-zinc-400 hover:bg-zinc-800 inline-flex items-center gap-2"
            >
              <LogOut size={14} /> Deactivate This Device
            </button>
          )}
        </div>
      )}
    </header>
  );
}
